'use client';

// Context
import { HomepageProvider } from '@src/context/homepage-ctx';

// Components
import Hero from '@src/components/organism/homepage/hero';
import ListProperty from '@src/components/organism/homepage/list-property';
import { DedicatedImage } from '@src/components/organism/shared/dedicated';

// Components shared
import Navbar from '@src/components/organism/shared/navbar';
import NavbarMobile from '@src/components/organism/shared/navbar-mobile';
import Mitra from '@src/components/organism/shared/mitra';
import Footer from '@src/components/organism/shared/footer';
import GoldenProperty from '@src/components/organism/shared/golder-property';

const Homepage = () => {
  return (
    <HomepageProvider>
      <div>
        <Navbar />
        <div className="hidden dd2-xl:block">
          <NavbarMobile />
        </div>
        
        <Hero />
        <ListProperty />
        {/* <Mitra /> */}
        <DedicatedImage />
        <GoldenProperty />
        <Footer />
      </div>
    </HomepageProvider>
  );
};

export default Homepage;
